import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Typography, Card, Alert, message } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const { Title, Text } = Typography;

const ResetPasswordPage = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');

  const [errorAlert, setErrorAlert] = useState({ visible: false, message: '' });
  const [successAlert, setSuccessAlert] = useState({ visible: false, message: '' });
  const [hasToken, setHasToken] = useState(true);

  useEffect(() => {
    if (!token) {
      setErrorAlert({
        visible: true,
        message: 'No reset token provided. Please use the link from your email.',
      });
      setHasToken(false);
    }
  }, [token]);

  const handleSubmit = async (values) => {
    setErrorAlert({ visible: false, message: '' });
    setSuccessAlert({ visible: false, message: '' });

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/user/password`,
        {
          password: values.password,
          token: token,
        }
      );
      if (response.status === 200) {
        setSuccessAlert({
          visible: true,
          message: 'Your password has been changed. You may now log in.',
        });
        message.success('Password reset successful');
      }
    } catch (error) {
      setErrorAlert({
        visible: true,
        message: error.response?.data?.reason ?? 'Unable to update password. Please check and try again.',
      });
    }
  };

  const handleBackToLogin = () => {
    navigate('/ui/login');
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f6f6f6',
      }}
    >
      <Card style={{ width: 650, padding: '40px 40px 32px 40px' }}>
        <Title level={2}>Reset Password</Title>
        <Text>Enter a new password to update your account.</Text>

        {errorAlert.visible && (
          <Alert
            style={{ marginTop: 16, marginBottom: 16 }}
            message={errorAlert.message}
            type="error"
            closable
            onClose={() => setErrorAlert({ ...errorAlert, visible: false })}
          />
        )}

        {successAlert.visible && (
          <Alert
            style={{ marginTop: 16, marginBottom: 16 }}
            message={
              <span>
                {successAlert.message}{' '}
                <Button type="link" onClick={handleBackToLogin}>
                  Click here to login
                </Button>
              </span>
            }
            type="success"
            closable
            onClose={() => setSuccessAlert({ ...successAlert, visible: false })}
          />
        )}

        {hasToken && !successAlert.visible && (
          <Form form={form} name="reset-password" layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              label="New Password"
              name="password"
              rules={[
                { required: true, message: 'Please enter your new password!' },
                { min: 8, message: 'Password must be at least 8 characters.' },
              ]}
            >
              <Input.Password placeholder="New password" autoFocus />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Submit
              </Button>
            </Form.Item>
            <Form.Item>
              <Button type="default" block onClick={handleBackToLogin}>
                Return to login
              </Button>
            </Form.Item>
          </Form>
        )}
      </Card>
    </div>
  );
};

export default ResetPasswordPage;
